class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.requestSequence = 0;
		this.requestController = null;
		this.generateRecommendations();
	}

	disconnectedCallback(){
		this.requestController?.abort();
	}

	getPaidSeedItem(){
		const cartForm = document.getElementById('AjaxCartForm');

		if ( ! cartForm ) {
			return null;
		}

		return Array.from(cartForm.querySelectorAll('[data-js-cart-item]'))
			.find(item => item.dataset.lalaAutoGift !== 'true') || null;
	}

	generateRecommendations(){
		const seedItem = this.getPaidSeedItem();
		const requestSequence = ++this.requestSequence;

		this.requestController?.abort();
		this.requestController = null;

		if ( ! seedItem?.dataset.productId ) {
			this.replaceChildren();
			this.removeAttribute('aria-busy');
			return Promise.resolve();
		}

		const controller = new AbortController();
		this.requestController = controller;
		this.setAttribute('aria-busy', 'true');

		return fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${seedItem.dataset.productId}&limit=${this.dataset.limit}`, {
			signal: controller.signal
		})
			.then(response => {
				if ( ! response.ok ) {
					throw new Error(`Cart recommendations failed with status ${response.status}`);
				}
				return response.text();
			})
			.then(text => {
				if ( requestSequence !== this.requestSequence ) {
					return;
				}

				const innerHTML = new DOMParser()
					.parseFromString(text, 'text/html')
					.querySelector('[data-js-cart-recommendations-performed]');

				if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
					this.innerHTML = innerHTML.innerHTML;
				} else {
					this.replaceChildren();
				}
			})
			.catch(error => {
				if ( error.name !== 'AbortError' && requestSequence === this.requestSequence ) {
					console.warn(error);
				}
			})
			.finally(() => {
				if ( requestSequence === this.requestSequence ) {
					this.removeAttribute('aria-busy');
					this.requestController = null;
				}
			});
	}
}

if ( ! customElements.get('cart-recommendations') ) {
	customElements.define('cart-recommendations', CartRecommendations);
}
